import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React from "react";
import { useMatchDetailsContext } from "./matchDetails/MatchDetailsContext";
// Remove unused homePlayers and awayPlayers from usePlayersByMatch
// import { usePlayersByMatch } from "./matchDetails/usePlayersByMatch";

interface MatchFormActionsProps {
  onSave: () => void | Promise<void>;
  onPopulateSampleData?: () => void;
  isVertical?: boolean;
}

const MatchFormActions: React.FC<MatchFormActionsProps> = ({
  onSave,
  onPopulateSampleData,
  isVertical = true,
}) => {
  const { matchId } = useMatchDetailsContext();
  // const { homePlayers, awayPlayers } = usePlayersByMatch(matchId || -1);
  // --- Navigation logic for matches ---
  // Get match list from context (ScheduleSection sets matchId and provides match list via spieltagData[selected]?.matches)
  // We'll use window for a quick solution, but ideally this should be lifted to context or passed as prop.
  const [matchList, setMatchList] = React.useState<number[]>([]);
  React.useEffect(() => {
    // Try to get match list from window (set by ScheduleSection for admin)
    if (window && (window as any).currentMatchList) {
      setMatchList((window as any).currentMatchList);
    }
  }, [matchId]);

  const { setMatchId } = useMatchDetailsContext();
  const currentIdx = matchList.findIndex((id) => id === matchId);
  const goToPrevMatch = () => {
    if (currentIdx > 0) setMatchId(matchList[currentIdx - 1]);
  };
  const goToNextMatch = () => {
    if (currentIdx >= 0 && currentIdx < matchList.length - 1)
      setMatchId(matchList[currentIdx + 1]);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: isVertical ? "column" : "row", sm: "row" },
          justifyContent: "flex-end",
          alignItems: { xs: isVertical ? "stretch" : "center", sm: "center" },
          mt: 2,
          gap: { xs: 1, sm: 2 },
        }}
      >
        <Button
          onClick={goToPrevMatch}
          disabled={currentIdx <= 0}
          variant="outlined"
          sx={{
            minWidth: { xs: isVertical ? "100%" : 80, sm: 120 },
            maxWidth: { xs: isVertical ? "none" : 90, sm: "none" },
            opacity: currentIdx <= 0 ? 0.5 : 1,
          }}
        >
          Zurück
        </Button>
        <Button
          onClick={goToNextMatch}
          disabled={currentIdx < 0 || currentIdx >= matchList.length - 1}
          variant="outlined"
          sx={{
            minWidth: { xs: isVertical ? "100%" : 80, sm: 120 },
            maxWidth: { xs: isVertical ? "none" : 90, sm: "none" },
            opacity:
              currentIdx < 0 || currentIdx >= matchList.length - 1 ? 0.5 : 1,
          }}
        >
          Weiter
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          sx={{
            minWidth: { xs: isVertical ? "100%" : 80, sm: 120 },
            maxWidth: { xs: isVertical ? "none" : 90, sm: "none" },
          }}
        >
          Speichern
        </Button>
        {process.env.NODE_ENV === "development" && (
          <Button
            onClick={onPopulateSampleData}
            variant="outlined"
            sx={{
              minWidth: { xs: isVertical ? "100%" : 40, sm: 56 },
              maxWidth: { xs: "none", sm: 56 },
              px: { xs: 1, sm: 0 },
            }}
          >
            ?
          </Button>
        )}
      </Box>
    </>
  );
};

export default MatchFormActions;
